import { z } from 'zod';

import { IsoDate } from './primitives';

export const ArticleBodyBlock = z.object({
  kind: z.enum(['paragraph', 'heading', 'quote', 'code', 'figure']),
  text: z.string().optional(),
  level: z.number().int().min(2).max(4).optional(),
  language: z.string().optional(),
  caption: z.string().optional(),
});

export const ArticleSchema = z.object({
  id: z.string().regex(/^a\d{2,3}$/, 'article id like a01, a002 expected'),
  cat: z.enum(['Research', 'Market Note', 'Technical']),
  title: z.string().min(5),
  author: z.string(),
  date: IsoDate,
  read: z.number().int().positive(),
  tag: z.string(),
  hero: z.boolean().optional(),
  lead: z.string().min(30),
  body: z.array(ArticleBodyBlock).optional(),
});

export type Article = z.infer<typeof ArticleSchema>;
export type ArticleBodyBlock = z.infer<typeof ArticleBodyBlock>;
